import actionStatus from '../constants/actionStatus';
import actionType from '../constants/actionType';
import * as journeyResponses from '../constants/journeyResponseMessages';

export const getActivateFxAccountActionHeading = (status) => {
  switch (status) {
    case actionStatus.SUCCESS:
      return journeyResponses.FX_ACCOUNT_ACTIVATION_SUCCESS;
    case actionStatus.FAILED:
      return journeyResponses.FX_ACCOUNT_ACTIVATION_FAILED;
    case actionStatus.PARTIAL:
      return journeyResponses.FX_ACCOUNT_ACTIVATION_PARTIAL;
    default:
      return null;
  }
};

export const getUpdatePasswordActionHeading = (status) => {
  switch (status) {
    case actionStatus.SUCCESS:
      return journeyResponses.FX_ACCOUNT_PASSWORD_UPDATE_SUCCESS;
    case actionStatus.FAILED:
      return journeyResponses.FX_ACCOUNT_PASSWORD_UPDATE_FAILED;
    case actionStatus.PARTIAL:
      return journeyResponses.FX_ACCOUNT_PASSWORD_UPDATE_PARTIAL;
    default:
      return null;
  }
};

export const getUpdateContactActionHeading = (status) => {
  switch (status) {
    case actionStatus.SUCCESS:
      return journeyResponses.UPDATE_CONTACT_SUCCESS;
    case actionStatus.FAILED:
      return journeyResponses.UPDATE_CONTACT_FAILED;
    default:
      return null;
  }
};

export const getActionHeading = (action, status) => {
  switch (action) {
    case actionType.UPDATE_FX_ACCOUNT_PASSSWORD.name:
      return getUpdatePasswordActionHeading(status);
    case actionType.ACTIVATE_FX_ACCOUNT.name:
      return getActivateFxAccountActionHeading(status);
    case actionType.UPDATE_CONTACT.name:
      return getUpdateContactActionHeading(status);
    default:
      return null;
  }
};
